import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/primitives";
import { INDUSTRIES } from "@/data/content";

export default function IndustriesSection() {
    return (
        <section className="border-t border-border py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
                    <div className="lg:col-span-8">
                        <Reveal>
                            <Eyebrow>Industries</Eyebrow>
                        </Reveal>
                        <Reveal delay={0.05}>
                            <h2 className="mt-5 max-w-2xl text-balance text-4xl font-bold leading-[1.1] tracking-tight md:text-5xl">
                                Built exclusively for shipping &amp; logistics
                            </h2>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-4">
                        <Reveal delay={0.1}>
                            <p className="text-lg leading-relaxed text-muted-foreground">
                                We work with the businesses that keep global
                                trade moving, and understand their operations
                                deeply.
                            </p>
                        </Reveal>
                    </div>
                </div>

                <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {INDUSTRIES.map((c, i) => {
                        const Icon = c.icon;
                        return (
                            <Reveal key={c.title} delay={(i % 3) * 0.06}>
                                <motion.div
                                    whileHover={{ y: -6 }}
                                    transition={{
                                        duration: 0.4,
                                        ease: [0.16, 1, 0.3, 1],
                                    }}
                                    className="group relative flex items-center justify-between overflow-hidden rounded-3xl border border-border bg-card p-8 transition-colors duration-300 hover:border-foreground/25"
                                >
                                    <div className="flex items-center gap-4">
                                        <div className="grid h-12 w-12 place-items-center rounded-xl border border-border bg-background text-navy transition-colors duration-300 group-hover:border-navy/40">
                                            <Icon
                                                className="h-5 w-5"
                                                strokeWidth={1.5}
                                            />
                                        </div>
                                        <h3 className="text-lg font-semibold tracking-tight">
                                            {c.title}
                                        </h3>
                                    </div>
                                    <ArrowUpRight
                                        className="h-5 w-5 text-muted-foreground transition-all duration-300 ease-premium group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-navy"
                                        strokeWidth={1.5}
                                    />
                                </motion.div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
